// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface QuestionMarkSmallIconSignature {
  Element: SVGSVGElement;
}

export const QuestionMarkSmallIcon: TOC<QuestionMarkSmallIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M11 12V15H13V13.875C14.723 13.428 16 11.86 16 10C16 7.795 14.205 6 12 6C9.795 6 8 7.795 8 10H10C10 8.896 10.896 8 12 8C13.104 8 14 8.896 14 10C14 11.103 13.104 12 12 12H11ZM12 18.25C12.6904 18.25 13.25 17.6904 13.25 17C13.25 16.3096 12.6904 15.75 12 15.75C11.3096 15.75 10.75 16.3096 10.75 17C10.75 17.6904 11.3096 18.25 12 18.25Z"/>
</svg>
</template>;